import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Manila',
    description:
        'Real-time performance management. From financial metrics to sales and marketing data, Manila gives you a holistic view of your business operations.',
    url: '',
    ogImage: '/images/Manila-Share.webp'
}
